import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function Image({ src }) {
  const animationProps = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };

  return (
    <AnimatePresence>
      <motion.img
        src={src}
        className="w-full rounded-xl"
        {...animationProps}
        alt="Sent image"
      />
    </AnimatePresence>
  );
}
